import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { pt } from './locales/pt'
import { en } from './locales/en'
import { es } from './locales/es'
import { getI18nLanguageFromPathname } from '../lib/publicLocaleRouting'

const initialPublicLanguage =
  typeof window !== 'undefined' ? getI18nLanguageFromPathname(window.location.pathname) : undefined

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialPublicLanguage,
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en', 'es'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ambcar-language',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
export const SUPPORTED_LANGUAGES = [
  { code: 'pt', labelKey: 'ui.languageSwitcher.languages.pt', flag: '🇧🇷' },
  { code: 'en', labelKey: 'ui.languageSwitcher.languages.en', flag: '🇺🇸' },
  { code: 'es', labelKey: 'ui.languageSwitcher.languages.es', flag: '🇪🇸' },
] as const
